// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cta[data-v-deea319e]{margin-top:3rem;max-width:none;padding:2.5rem;text-align:center;width:auto;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;user-select:none}.cta.push-bottom[data-v-deea319e]{bottom:0;position:absolute}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
